<!-- GenericPage Copyright 2022 Rebecca L Beaudet -->
<script lang="ts">
  import { logoPath } from '../language/constantContent';
  import type { pageContentI } from '../language/interface';
  import Accordions from './pageComponents/Accordions.svelte';
  import ListGroups from './pageComponents/ListGroups.svelte';

  export let content: pageContentI = {
    path: '404',
    navName: '404',
    header: 'Page not found',
    img: logoPath,
    sections: [{ paragraph: 'The page you are looking for does not exist.' }],
  };

  const figureSize = (): number => {
    let elements = 0;
    if (content?.accordions) elements++;
    if (content?.img) elements++;
    if (content?.listGroup) elements++;
    if (elements === 3) return 3;
    if (elements === 2) return 6;
    if (elements === 1) return 9;
    return 12;
  };
</script>

<div class="container mt-4">
  <div class="row">
    {#if content?.img}
      <div class="col-md-3 mb-3">
        <img
          width="100%"
          height="100%"
          src={content.img}
          alt={content?.imgAltTxt ? content.imgAltTxt : content.header}
          class="bd-placeholder-img bd-placeholder-img-lg img-fluid rounded text-center"
        />
      </div>
    {/if}
    <div class={`mb-3 col-md-${figureSize()}`}>
      <h3>{content.header}</h3>
      {#each content.sections as section}
        <p>{section.paragraph}</p>
        {#if section.list}
          <ol>
            {#each section.list as item}
              <li>{item}</li>
            {/each}
          </ol>
        {/if}
      {/each}
      {#if content?.email}
        <a href="mailto:{content.email}">{content.email}</a>
      {/if}
      {#if content?.link}
        <a href={content.link}>{content.linkText}</a>
      {/if}
      {#if content?.video}
        <div class="vh-50">
          <iframe
            title="Online Learning Introduction"
            class="w-100 mb-2"
            style="height: 55vh;"
            src={`https://youtube.com/embed/${content.video}`}
            allow="autoplay; encrypted-media"
            allowfullscreen={true}
            width="560"
            height="315"
            frameborder="0"
          />
        </div>
      {/if}
    </div>
    <Accordions
      sections={content?.accordions?.group ? content.accordions.group : []}
      heading={content?.accordions?.heading ? content.accordions.heading : ''}
    />
    <ListGroups
      listGroup={content?.listGroup
        ? content.listGroup
        : { heading: '', group: [] }}
    />
  </div>
</div>
